import { NewsletterError } from '@/types/homepage.types';

export const getErrorMessage = (error: NewsletterError | null) => {
  switch (error?.statusCode) {
    case 400:
      return 'Please enter a valid email.';
    case 429:
      return 'Too many attempts. Try again later.';
    case 502:
      return 'Service temporarily unavailable. Please try again.';
    case 403:
      return 'Captcha verification failed.';
    default:
      return 'Something went wrong. Please try again.';
  }
};
